/**
 * Importes de un pedido tal y como se MUESTRAN (listado y detalle). Un solo sitio
 * para las dos reglas que han dado guerra:
 *
 *  - PRO (Calculadora Profesional): finalAmount/totalAmount ya vienen redondeados, se
 *    muestran tal cual.
 *  - TPV: finalAmount = lo que PAGA el cliente (descuento ya aplicado, IVA incluido),
 *    semántica POST-descuento unificada en jul-2026. Se redondea a 5 cts y el subtotal
 *    pre-descuento se DERIVA dividiendo: nunca volver a restar el descuento (doblaba el
 *    descuento, bug #2132).
 */

// Redondeo a 5 céntimos hacia arriba, con tolerancia para no subir un múltiplo exacto
// que llega con ruido de coma flotante (p.ej. 114,35 * 20 = 2286,9999999).
export const roundToFiveCents = (number) => {
  const scaled = number * 20;
  const nearest = Math.round(scaled);
  if (Math.abs(scaled - nearest) < 0.01) return nearest / 20;
  return Math.ceil(scaled) / 20;
};

// ¿Pedido de la Calculadora Profesional? Manda orderType; los antiguos sin él se
// reconocen por el fingerprint (INT-/EXT-).
export const isCalculadoraPro = (order) => {
  if (!order) return false;
  if (order.orderType) return order.orderType === 'PRO';
  const fp = order.fingerprint || '';
  return fp.startsWith('INT-') || fp.startsWith('EXT-');
};

// Total a mostrar. Un precio manual se respeta exacto (sin redondear).
export const calculateDisplayFinalAmount = (order) => {
  if (!order) return 0;
  const finalAmount = parseFloat(order.finalAmount || order.totalAmount || 0);

  if (order.metadata?.isManualPrice && order.metadata?.manualFinalAmount) {
    return parseFloat(order.metadata.manualFinalAmount);
  }

  if (!isCalculadoraPro(order)) {
    return roundToFiveCents(finalAmount);
  }

  return finalAmount;
};

// Base imponible a mostrar. En TPV se deriva del total redondeado para que cuadren
// (169,23 -> 169,25 -> base 139,88).
export const calculateDisplayBaseAmount = (order) => {
  if (!order) return 0;
  if (isCalculadoraPro(order)) {
    return parseFloat(order.totalAmount || 0);
  }
  return calculateDisplayFinalAmount(order) / 1.21;
};

// Desglose TPV para la pantalla: subtotal (IVA inc.) pre-descuento derivado del total,
// importe del descuento y total. `hasDiscount` es falso con 0 % o 100 % (división por cero).
export const tpvDisplayBreakdown = (order) => {
  const total = calculateDisplayFinalAmount(order);
  const discountPercentage = parseFloat(order?.discountPercentage) || 0;
  const hasDiscount = discountPercentage > 0 && discountPercentage < 100;
  const subtotal = hasDiscount ? total / (1 - discountPercentage / 100) : total;
  return {
    total,
    subtotal,
    discountPercentage,
    discountAmount: subtotal - total,
    hasDiscount
  };
};
